<template>
  <div>
    <div id="printContent" class="container">
      <table v-if="data.stage === 5" style="padding: 0; margin: 0;">
        <tr>
          <!-- MA 图标已移除，保留同尺寸占位(110x55)保持原版面 -->
          <td>
            <div style="width: 110px; height: 55px;" />
          </td>
          <td style="text-align: right;">
            <div v-html="qrCode" />
          </td>
        </tr>
      </table>
      <div style="text-align: center;" align="center"><span style="font-family: simsun, serif; font-size: 20px;">在用车检验（测）报告</span></div>
      <div style="text-align: center;">
        <span style="font-family: simsun, serif; font-size: 12px;">
          检测报告编号：<span style="font-family: simsun, serif; font-size: 12px; padding-right: 20px;">{{ data.report_number }}</span>
          检验日期：<span style="font-family: simsun, serif; font-size: 12px; padding-right: 20px;">{{ data.inspection_date }}</span>
          计量认证号：251205342539
        </span>
      </div>
      <table style="border-collapse: collapse; width: 100.033%; height: 1200px; border-color: #000000; border-style: solid;" border="1">
        <tbody>
          <tr style="height: 24.0652px;">
            <td style="width: 99.8814%; height: 24.0652px;" colspan="8"><span style="font-size: 14px;"><strong><span style="font-family: simsun, serif;">1、基础信息</span></strong></span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 47.9336%; height: 20.0522px;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">检验机构名称：安徽申环检测认证有限公司</span></td>
            <td style="width: 51.9478%; height: 20.0522px;" colspan="5"><span style="font-family: simsun, serif; font-size: 12px;">联系电话：<span lang="en-us" xml:lang="en-us">0551-62857172</span></span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 99.8814%; height: 20.0522px;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">检验机构地址：安徽省合肥市经济技术开发区芙蓉路与轿顶路交口东北天润大厦<span lang="en-us" xml:lang="en-us">1703</span>室</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 99.8814%; height: 20.0522px;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">检测地点：{{ data.inspection_location_province + data.inspection_location_city + data.inspection_location_address }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">号牌号码</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.license_plate_number }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">车辆型号</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.vehicle_model }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">基准质量（<span lang="en-us" xml:lang="en-us">kg</span>）</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.base_mass }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">车辆识别代码（VIN）</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.vehicle_identification_number }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">最大设计总质量（<span lang="en-us" xml:lang="en-us">kg</span>）</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.max_design_mass }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">发动机型号</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.engine_model }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">发动机号码</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.engine_number }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">发动机排量（<span lang="en-us" xml:lang="en-us">L</span>）</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.engine_displacement }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">额定转速<span lang="en-us" xml:lang="en-us">(r/min)</span></span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.rated_speed }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">发动机额定功率(kW)</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.rated_power }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">DPF</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.dpf }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;"><span lang="en-us" xml:lang="en-us">DPF</span>型号</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.dpf_model }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">SCR</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.scr }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;"><span lang="en-us" xml:lang="en-us">SCR</span>型号</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.scr_model }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">气缸数</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.cylinder_count }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">发动机厂家</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.engine_manufacturer }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">储能装置型号</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.energy_storage_model }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">电池容量</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.battery_capacity }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">车辆生产企业</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.vehicle_manufacturer }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">车辆出厂日期</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.manufacture_date }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">累计行驶里程（<span lang="en-us" xml:lang="en-us">km</span>）</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.mileage }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">车主姓名（单位）</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.owner_name }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">联系电话</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.owner_contact }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">车牌颜色</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.license_plate_color }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">燃料类型</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.fuel_type }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">燃油型式</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.fuel_style }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">驱动方式</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.drive_mode }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">车辆品牌</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.vehicle_brand }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">变速器型式</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.transmission_type }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">使用性质</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.usage_nature }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">初次登记日期</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.initial_registration_date }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">检测方法</span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.inspection_method }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span lang="en-us" style="font-family: simsun, serif; font-size: 12px;" xml:lang="en-us">OBD</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.obd }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 99.8814%; height: 20.0522px; text-align: center;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">环境参数</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">环境温度（℃）</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.ambient_temperature }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">大气压（<span lang="en-us" xml:lang="en-us">kPa</span>）</span></td>
            <td style="height: 20.0522px; width: 17.9527%; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.atmospheric_pressure }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">相对湿度（<span lang="en-us" xml:lang="en-us">%</span>）</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.relative_humidity }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="height: 20.0522px; width: 99.8814%; text-align: center;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">检测设备信息</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">分析仪生产企业</span></td>
            <td style="width: 16.5288%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.analyzer_manufacturer }}</span></td>
            <td style="width: 17.4663%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">分析仪型号<span lang="en-us" xml:lang="en-us">/</span>编号</span></td>
            <td style="height: 20.0522px; width: 17.9527%; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.analyzer_model }}</span></td>
            <td style="width: 14.7579%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">检定<span lang="en-us" xml:lang="en-us">/</span>校准有效期至</span></td>
            <td style="width: 17.2372%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.verification_expiration }}</span></td>
          </tr>
          <tr style="height: 24.0652px;">
            <td style="height: 24.0652px; width: 99.8814%; text-align: left;" colspan="8"><strong><span style="font-family: simsun, serif; font-size: 14px;"><span lang="en-us" xml:lang="en-us">2</span>、排气污染物检测</span></strong></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: left;"><span style="font-family: simsun, serif; font-size: 12px;">检测标准</span></td>
            <td style="width: 83.9429%; height: 20.0522px; text-align: left;" colspan="7"><span style="font-family: simsun, serif; font-size: 12px;">《柴油车排气污染物排放限值及测量方法》（自由加速法及加载减速法）<span lang="en-us" xml:lang="en-us">GB3847-2018</span></span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: left;"><span style="font-family: simsun, serif; font-size: 12px;">检测方法</span></td>
            <td style="width: 83.9429%; height: 20.0522px; text-align: left;" colspan="7"><span style="font-family: simsun, serif; font-size: 12px;"><span lang="en-us" xml:lang="en-us">GB3847-2018</span>附录<span lang="en-us" xml:lang="en-us">A</span>自由加速法</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 99.8814%; height: 20.0522px; text-align: left;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">检测结果内容</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; text-align: center;" rowspan="4"><span style="font-family: simsun, serif; font-size: 12px;">排气污染物测试</span></td>
            <td style="width: 83.9429%; text-align: center; height: 20.0522px;" colspan="7"><span style="font-family: simsun, serif; font-size: 12px;">自由加速</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 16.5288%; text-align: center;" rowspan="2"><span style="font-family: simsun, serif; font-size: 12px;">额定转速<span lang="en-us" xml:lang="en-us">(r/min)</span></span></td>
            <td style=" width: 17.4663%; text-align: center;" rowspan="2"><span style="font-family: simsun, serif; font-size: 12px;">实测转速<span lang="en-us" xml:lang="en-us">(r/min)</span></span></td>
            <td style="width: 17.9527%; height: 20.0522px; text-align: center;" colspan="3"><span style="font-family: simsun, serif; font-size: 12px;">最后三次烟度测量值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup>）</span></span></td>
            <td style="width: 14.7579%; text-align: center;" rowspan="2"><span style="font-family: simsun, serif; font-size: 12px;">平均值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</span></td>
            <td style="width: 17.2372%; text-align: center;" rowspan="2"><span style="font-family: simsun, serif; font-size: 12px;">限值（<span lang="en-us" xml:lang="en-us">m<sup>-1</sup></span>）</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 6.37541%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">1</span></td>
            <td style="width: 6.72904%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">2</span></td>
            <td style="width: 6.84822%; height: 20.0522px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">3</span></td>
          </tr>
          <tr style="height: 22.3957px;">
            <td style="width: 16.5288%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.rated_rpm }}</span></td>
            <td style="width: 17.4663%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.measured_rpm }}</span></td>
            <td style="width: 6.37541%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.opacity_value1 }}</span></td>
            <td style="width: 6.72904%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.opacity_value2 }}</span></td>
            <td style="width: 6.84822%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.opacity_value3 }}</span></td>
            <td style="width: 14.7579%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.average_opacity }}</span></td>
            <td style="width: 17.2372%; height: 22.3957px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">{{ data.limit_value }}</span></td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="width: 15.9385%; height: 20.0522px; text-align: left;"><span style="font-family: simsun, serif; font-size: 12px;">检测结果</span></td>
            <td style="height: 20.0522px; width: 83.9429%; text-align: left;" colspan="7">
              <span v-if="data.inspection_result === '合格'" style="font-family: simsun, serif; font-size: 12px;">&nbsp;合格&nbsp;☑&nbsp;&nbsp;不合格&nbsp;□</span>
              <span v-if="data.inspection_result === '不合格'" style="font-family: simsun, serif; font-size: 12px;">&nbsp;合格&nbsp;□&nbsp;&nbsp;不合格&nbsp;☑</span>
            </td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="height: 20.0522px; width: 99.8814%; text-align: left;" colspan="8">
              <div style="float: left; height: 38px; line-height: 38px;">检验：</div>
              <div style="float: left; margin-top: 5px; width: 100px; margin-left: 10px;"><img v-if="data.inspector_sign" :src="baseURL + data.inspector_sign" style="width: 80px;" alt=""></div>
              <div style="float: left; height: 38px; line-height: 38px;">审核：</div>
              <div style="float: left; margin-top: 5px; width: 100px; margin-left: 10px;"><img v-if="data.reviewer_sign" :src="baseURL + data.reviewer_sign" style="width: 80px;" alt=""></div>
              <div style="float: left; height: 38px; line-height: 38px;">批准：</div>
              <div style="float: left; margin-top: 5px; width: 100px; margin-left: 10px;"><img v-if="data.approver_sign" :src="baseURL + data.approver_sign" style="width: 80px;" alt=""></div>
              <div style="float: left; height: 38px; line-height: 38px;">批准日期：{{ data.approval_date }}</div>
              <div style="float: left; height: 38px; line-height: 38px; margin-left: 30px;">检测机构（盖章）：</div>
              <img src="../../../assets/gz.png" alt="" class="gz-img">
            </td>
          </tr>
          <tr style="height: 53.2609px;">
            <td style="width: 15.9385%; height: 53.2609px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">备注</span></td>
            <td style="height: 53.2609px; width: 83.9429%; text-align: left;" colspan="7"><span style="font-family: simsun, serif; font-size: 12px;">说明：<span lang="en-us" xml:lang="en-us">1</span>、本报告须同时具有检测专用章、<span lang="en-us" xml:lang="en-us">CMA</span>章及检测<span lang="en-us" xml:lang="en-us">/</span>审核<span lang="en-us" xml:lang="en-us">/</span>批准人员签字，缺少其中之一则报告无效；<span lang="en-us" xml:lang="en-us">2</span>、本报告未经本机构批准，不得复制（全文复制除外）；<span lang="en-us" xml:lang="en-us">3</span>、本报告检测数据仅对被检品检测时结果负责；<span lang="en-us" xml:lang="en-us">4</span>、受检单位对检测结论如有异议，请于收到报告之日起十五天内，以书面形式向检验机构提出，逾期不予受理。</span></td>
          </tr>
          <tr style="height: 80.039px;">
            <td style="width: 15.9385%; height: 80.039px; text-align: center;"><span style="font-family: simsun, serif; font-size: 12px;">车辆照片</span></td>
            <td style="height: 80.039px; width: 83.9429%; text-align: center;" colspan="7">
              <!--     vehicle_photo展示       -->
              <div v-for="(photo, index) in data.vehicle_photo" :key="index" :class="index < 3 ? 'photo' : ''">
                <div v-if="!photo" style="margin-top: 55px;">/</div>
                <img v-else :src="photo" style="height: 110px; margin: 5px 5px -90px 5px;" alt="">
              </div>
            </td>
          </tr>
          <tr style="height: 20.0522px;">
            <td style="height: 20.0522px; width: 99.8814%; text-align: center;" colspan="8"><span style="font-family: simsun, serif; font-size: 12px;">以下空白</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 审核记录   -->
    <el-row>
      <el-col :span="24">
        <el-table :data="data.approved_memo" style="width: 100%">
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span v-if="scope.row.role === 1">检测员</span>
              <span v-if="scope.row.role === 2">审核员</span>
              <span v-if="scope.row.role === 3">批准员</span>
            </template>
          </el-table-column>
          <el-table-column label="审核结果" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.result === 1">通过</span>
              <span v-if="scope.row.result === 2">不通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="审核时间" />
          <el-table-column prop="user_sign" label="签名" width="100">
            <template slot-scope="scope">
              <img :src="baseURL + scope.row.user_sign" alt="" style="width: 100px;">
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div style="height: 50px;" />
    <el-form ref="form" :model="onRoadForm" :rules="rules" label-width="100px">
      <!--  通过、不通过     -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="审核结果" prop="result">
            <el-radio-group v-model="onRoadForm.result">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="签名">
            <div v-if="!resultImg">
              <vue-esign ref="esign" :width="800" :height="300" :is-crop="isCrop" :line-width="lineWidth" :line-color="lineColor" :bg-color.sync="bgColor" style="border: 1px solid #CCCCCC" />
              <button class="sign-btn" @click="handleReset">清空画板</button>
              <button class="sign-btn" @click="handleGenerate">确认签名</button>
            </div>
            <!--  展示签名图片        -->
            <img v-if="resultImg" :src="resultImg" alt="" style="width: 30%; height: 30%; margin-top: 12px;">
            <!--  重新签名        -->
            <el-button v-if="resultImg" @click="handleResetSign">重新签名</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 打印按钮  -->
    <div style="text-align: center;">
      <el-button v-print="printOption" type="default">打印</el-button>
      <el-button type="primary" @click="submit">确认审核</el-button>
    </div>
  </div>
</template>

<script>
import vueEsign from 'vue-esign'
import { detailOnRoad, checkOnRoad } from '@/api/approver'
import { uploadBase64 } from '@/api/common'
import axios from 'axios'
import { getToken } from '@/utils/auth'
export default {
  name: 'PreviewOnRoad',
  components: {
    vueEsign
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      id: 0,
      dialogVisible: false,
      printOption: {
        id: 'printContent',
        popTitle: '打印',
        extraHead: '<meta http-equiv="Content-Language" content="zh-cn" />'
      },
      data: {
        uuid: '',
        report_number: '',
        inspection_date: '',
        license_plate_number: '',
        vehicle_model: '',
        base_mass: '',
        vehicle_identification_number: '',
        max_design_mass: '',
        engine_model: '',
        engine_number: '',
        engine_displacement: '',
        rated_speed: '',
        rated_power: '',
        dpf: '',
        dpf_model: '',
        scr: '',
        scr_model: '',
        cylinder_count: '',
        engine_manufacturer: '',
        energy_storage_model: '',
        battery_capacity: '',
        vehicle_manufacturer: '',
        manufacture_date: '',
        mileage: '',
        owner_name: '',
        owner_contact: '',
        license_plate_color: '',
        fuel_type: '',
        fuel_style: '',
        drive_mode: '',
        vehicle_brand: '',
        transmission_type: '',
        usage_nature: '',
        initial_registration_date: '',
        inspection_method: '',
        obd: '',
        ambient_temperature: '',
        atmospheric_pressure: '',
        relative_humidity: '',
        analyzer_manufacturer: '',
        analyzer_model: '',
        verification_expiration: '',
        rated_rpm: '',
        measured_rpm: '',
        opacity_value1: '',
        opacity_value2: '',
        opacity_value3: '',
        average_opacity: '',
        limit_value: '',
        inspection_result: '',
        vehicle_photo: [],
        approved_memo: [],
        inspector_sign: '',
        reviewer_sign: '',
        approver_sign: '',
        approval_date: '',
        stage: ''
      },
      onRoadForm: {
        result: '',
        user_sign: ''
      },
      rules: {
        result: [{ required: true, message: '请选择审核结果', trigger: 'change' }]
      },
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      baseURL: process.env.VUE_APP_BASE_URL,
      qrCode: ''
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.fetchData(val.id)
        }
      },
      deep: true
    }
  },
  created() {
    const id = this.item.id
    this.id = id
    this.fetchData(id)
    if (this.$refs.form) {
      this.$refs.form.resetFields()
    }
  },
  methods: {
    fetchData(id) {
      detailOnRoad(id).then(response => {
        this.data = response.data
        this.data.inspection_date = this.formatDate(this.data.inspection_date)
        this.data.manufacture_date = this.data.manufacture_date ? this.formatDate(this.data.manufacture_date) : '/'
        this.data.initial_registration_date = this.formatDate(this.data.initial_registration_date)
        this.data.verification_expiration = this.formatDate(this.data.verification_expiration)
        // 空值处理为 ‘/’
        for (const key in this.data) {
          if (this.data[key] === null) {
            this.data[key] = '/'
          }
        }
        this.data.vehicle_photo = response.data.vehicle_photo.map(item => {
          return item ? this.baseURL + item : null
        })
        this.fetchQRCode()
      })
    },
    fetchQRCode() {
      const url = process.env.VUE_APP_API + '/common/qrcode' + '?text=' + this.data.uuid
      axios.get(url, {
        headers: {
          'Authorization': 'Bearer ' + getToken()
        }
      }).then(response => {
        this.qrCode = response.data
      }).catch(error => {
        console.error('Error fetching QR code:', error)
      })
    },
    // 打印 class=container 的内容
    print() {
      const content = document.querySelector('.container').innerHTML
      const printWindow = window.open('', '_blank')
      printWindow.document.open()
      printWindow.document.write(`
        <html>
          <head>
            <title>打印</title>
            <style>
              body {
                font-size: 12px;
                font-family: simsun, serif;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 20px;
              }
              tr td {
                padding: 0;
              }
              .el-image__preview {
                height: 80px;
              }
            </style>
          </head>
          <body>
            ${content}
          </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.print()
    },
    formatDate(dateString) {
      // 将日期字符串分割为年、月、日
      const parts = dateString.split('-')
      const year = parts[0]
      const month = parts[1]
      const day = parts[2]

      // 转换月和日的格式，确保它们是两位数
      const formattedMonth = month.length === 1 ? `0${month}` : month
      const formattedDay = day.length === 1 ? `0${day}` : day

      // 返回格式化后的日期字符串
      return `${year}年${formattedMonth}月${formattedDay}日`
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        uploadBase64({
          file: res
        }).then(response => {
          this.onRoadForm.user_sign = response.data.path
        })
      }).catch(err => {
        alert(err) // 画布没有签字时会执行这里 'Not Signned'
      })
    },
    handleResetSign() {
      this.resultImg = ''
      this.$refs.esign.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 签名
          if (!this.onRoadForm.user_sign) {
            this.$message.error('请签名')
            return
          }
          const params = {
            id: this.id,
            result: this.onRoadForm.result,
            memo: this.onRoadForm.memo,
            user_sign: this.onRoadForm.user_sign
          }
          checkOnRoad(params).then(response => {
            this.$message({
              message: '审核成功',
              type: 'success'
            })
            this.$emit('success:check')
          })
        }
      })
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
tr td {
  padding: 0;
}
.gz-img {
  width: 220px;
  height: 220px;
  margin-left: 12px;
  position: absolute;
  top: 1005px;
  right: 25px;
}
.photo {
  width: 25%;
  height: 100%;
  float: left;
  border-right: 1px solid #000000;
}
</style>
